document.addEventListener("DOMContentLoaded", function(){
    var btnScrollToTop = document.querySelectorAll(".moe-scroll-to-top");

    btnScrollToTop.forEach(function(item){
        item.addEventListener("click", function(event){
            event.preventDefault();
            window.scrollTo({top: 0, behavior: "smooth"});
        });
    });

});